<template>
  <InterfaceCard
      color="primary"
      icon="mdi-alert-circle"
      :title="this.dataDown.title"
  >
    <v-list
        class="with-white-spaces"
        :dense="$vuetify.breakpoint.mobile"
    >
      <v-list-item>
        <v-list-item-content >
          <v-img class="image by-center"
            :src="this.dataDown.image"
          ></v-img>
          <p class="text-center message" v-html="this.dataDown.message"></p>
          <div v-if="true" class="timer text-center">Осталось: <b>{{this.getTime | localizedTimer}}</b></div>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="dataDown.canClose"
          @click="$emit('close')"
          text
        >
          Закрыть
        </v-btn>
      </v-card-actions>
  </InterfaceCard>
</template>

<script>
import InterfaceCard from '@/components/InterfaceCard'

export default {
  name: 'Downtime',
  components: {InterfaceCard},
  props: {
    dataDown: {
      required: true,
      type: Object
    }
  },
  data () {
    return {
      getTime: 0
    }
  },
  methods: {
    timer () {
      this.getTime = Date.now()
      this.getTime = new Date(this.getTime).setHours(0, 0, 0)
      this.getTime = new Date(this.getTime).setMilliseconds(this.dataDown.downTo - Date.now())
    }
  },
  mounted () {
    this.timer()
    setInterval(() => this.timer(), 1000);
  }
}
</script>

<style scoped>
  .image {
    width: 100%;
    min-width: 320px;
    max-width: 400px;
  }
  .message {
    margin-top: 15px;
    font-size: 16px;
  }
  .timer {
    margin-top: 10px;
  }
</style>